import { GifterUsersListState } from "src/features/gifterStatistics/state/gifterStatisticsSlice";

export const getGifterUsersList = (state: GifterUsersListState) => state?.data;

export const getGifterUsersLoading = (state: GifterUsersListState) =>
  state?.loading;

export const getGifterUsersLoadingFailed = (state: GifterUsersListState) =>
  !!state.error;
